{
  "name": "pagos-ordenaris",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:prod": "ng serve --watch --configuration production",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:qa": "ng build --configuration qa",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:pagos-ordenaris": "node dist/pagos-ordenaris/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.23",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.23",
    "@angular/compiler": "^21.2.23",
    "@angular/core": "^21.2.23",
    "@angular/forms": "^21.2.23",
    "@angular/platform-browser": "^21.2.23",
    "@angular/platform-browser-dynamic": "^21.2.23",
    "@angular/platform-server": "^21.2.23",
    "@angular/router": "^21.2.23",
    "@angular/ssr": "^21.2.24",
    "express": "^4.18.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^10.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.23",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "@types/uuid": "^10.0.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "^4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "tailwindcss": "^3.4.13",
    "typescript": "~5.9.3"
  },
  "engines": {
    "node": "^22.0.0"
  }
}
